export const accountFields = {
  'JOINTLY':
    [
      'secondary.basicInfo.firstName',
      'secondary.basicInfo.lastName',
      'secondary.addressInfo.country',
      'secondary.personalInfo.phoneNumber',
      'secondary.addressInfo.Street1',
      'secondary.addressInfo.city',
      'secondary.addressInfo.state',
      'secondary.addressInfo.postalCode',
      'secondary.email',
      'basicInfo.firstName',
      'basicInfo.lastName',
      'addressInfo.country',
      'personalInfo.phoneNumber',
      'addressInfo.Street1',
      'addressInfo.city',
      'addressInfo.state',
      'addressInfo.postalCode',
    ],
  'IN_BEHALF_OF_AN_ENTITY':
    [
      'entityDetails.phoneNumber',
      'entityDetails.countryOfFormation',
      'entityDetails.ein',
      'entityDetails.companyName',
      'entityDetails.regionOfFormation',
      'entityDetails.email',
      'entityDetails.addressInfo.Street1',
      'entityDetails.addressInfo.city',
      'entityDetails.addressInfo.state',
      'entityDetails.addressInfo.postalCode',
      'entityDetails.type',
      'entityDetails.legalStructure',
      'basicInfo.firstName',
      'basicInfo.lastName',
      'addressInfo.country',
      'personalInfo.phoneNumber',
      'addressInfo.Street1',
      'addressInfo.city',
      'addressInfo.state',
      'addressInfo.postalCode',
      'entityDetails.titleWithCompany',
      'entityDetails.authorized',
    ],
  'RETIREMENT_TRUST_ACCOUNT':
    [
      'entityDetails.name',
      'entityDetails.ein',
      'entityDetails.authorized',
      'basicInfo.firstName',
      'basicInfo.lastName',
      'addressInfo.country',
      'personalInfo.phoneNumber',
      'addressInfo.Street1',
      'addressInfo.city',
      'addressInfo.state',
      'addressInfo.postalCode',
      'entityDetails.addressInfo.Street1',
      'entityDetails.addressInfo.country',
      'entityDetails.addressInfo.city',
      'entityDetails.addressInfo.state',
      'entityDetails.addressInfo.postalCode',
    ],
  'RETIREMENT_ACCOUNT':
    [
      'entityDetails.name',
      'entityDetails.ein',
      'entityDetails.authorized',
      'basicInfo.firstName',
      'basicInfo.lastName',
      'addressInfo.country',
      'personalInfo.phoneNumber',
      'addressInfo.Street1',
      'addressInfo.city',
      'addressInfo.state',
      'addressInfo.postalCode',
      'entityDetails.nameOfCustodian',
      'entityDetails.emailOfIraContact',
      'entityDetails.addressInfo.Street1',
      'entityDetails.addressInfo.country',
      'entityDetails.addressInfo.city',
      'entityDetails.addressInfo.state',
      'entityDetails.addressInfo.postalCode',
      'entityDetails.addressInfo.regionOfFormation',
    ],
  'FOR_MYSELF':
    [
      'basicInfo.firstName',
      'basicInfo.lastName',
      'addressInfo.country',
      'personalInfo.phoneNumber',
      'addressInfo.Street1',
      'addressInfo.city',
      'addressInfo.state',
      'addressInfo.postalCode'
    ]
}